import { Direction } from './Direction';
import { compareNaturalStrings } from './compareNaturalStrings';

export const sortNaturalString = ({
  a,
  b,
  sortDirection,
}: {
  a: string;
  b: string;
  sortDirection?: Direction;
}) => {
  if (sortDirection === Direction.Ascending) {
    return compareNaturalStrings(a, b);
  } else if (sortDirection === Direction.Descending) {
    return compareNaturalStrings(b, a);
  } else {
    return 0;
  }
};
